export default {
  nav: {
    home: '首页',
    articles: '文章',
    tech: '技术',
    software: '软件',
    tutorial: '教程',
    resource: '资源',
    news: '资讯',
    tools: '工具箱',
    about: '关于',
    sponsor: '会员',
    copyright: '版权声明'
  },
  header: {
    searchPlaceholder: '搜索文章...',
    searchMobilePlaceholder: '搜索文章、工具...',
    search: '搜索',
    navLabel: '导航',
    drawerHint: '滑动浏览 · 点按导航',
    openMenu: '打开菜单',
    closeMenu: '关闭菜单',
    langZh: '中文',
    langEn: 'EN'
  },
  footer: {
    nav: '导航',
    about: '关于',
    copyright: '版权声明',
    feedback: '反馈建议',
    followUs: '关注我们',
    channelsHint: '悬停或点击二维码可放大扫码'
  },
  home: {
    readMore: '阅读全文',
    noCarousel: '暂无轮播文章',
    noCarouselHint: '在后台文章管理中开启「首页轮播展示」',
    latest: '最新',
    featured: '精华',
    views: '阅读',
    softwareTitle: '软件推荐',
    softwareSubtitle: '精选实用软件，小工具、办公、开发应有尽有',
    tutorialTitle: '教程文章',
    tutorialSubtitle: '从入门到实战，系统化学习路径',
    resourceTitle: '资源分享',
    resourceSubtitle: '学习路线、开源项目、书籍推荐',
    techTitle: '技术文章',
    techSubtitle: '前端开发、工程化与性能优化',
    all: '全部'
  },
  articles: {
    count: '共 {n} 篇文章',
    searchPrefix: '搜索：{q}',
    all: '全部',
    tech: '技术',
    software: '软件',
    tutorial: '教程',
    resource: '资源',
    news: '资讯',
    titleAll: '全部文章',
    titleTech: '技术文章',
    titleSoftware: '软件推荐',
    titleTutorial: '教程文章',
    titleResource: '资源分享',
    titleNews: '资讯动态',
    subCategory: '子分类',
    softwareCats: '软件分类',
    tutorialCats: '教程分类',
    resourceCats: '资源分类',
    techCats: '技术分类',
    tags: '标签',
    empty: '没有找到相关文章',
    featured: '精华'
  },
  article: {
    home: '首页',
    body: '正文',
    back: '返回',
    repostFrom: '转载自：',
    readMinutes: '约 {n} 分钟',
    views: '阅读',
    copyLink: '复制链接',
    loadingBody: '正在加载正文…',
    thanks: '感谢阅读',
    moreType: '更多{type}',
    related: '相关推荐',
    loading: '正在加载文章…',
    notFound: '文章不存在',
    backToList: '返回文章列表',
    translationFallback: '暂无英文译文，显示中文原文'
  },
  tools: {
    badge: '在线工具箱',
    heroTitle: '实用工具，即开即用',
    heroDesc: 'PDF、图片、码制、站长、生活、运维与配置转换 — 全部在浏览器本地处理，安全快捷，无需上传服务器。',
    countTools: '款工具',
    countCats: '大分类',
    localPct: '本地处理',
    searchPlaceholder: '搜索工具，如 PDF 合并、二维码…',
    frequent: '常用工具',
    frequentHintLogin: '按你的使用习惯同步到账号，置顶可优先显示',
    frequentHintGuest: '本机记录最近使用；登录后可跨设备同步',
    clear: '清空',
    clearConfirm: '确定清空常用工具记录？',
    cleared: '已清空',
    pin: '置顶',
    unpin: '取消置顶',
    removeFrequent: '从常用移除',
    frequentEmpty: '使用过的工具会出现在这里，点击即可直达',
    all: '全部',
    toolsInCat: '{n} 个工具',
    empty: '没有找到匹配的工具',
    notFound: '工具不存在',
    backHub: '返回工具箱',
    allTools: '全部工具',
    loginRequired: '登录后使用',
    loginTip: '该工具需要登录账号后才能使用，登录后可在浏览器本地安全处理文件。',
    loginNow: '立即登录',
    tip: '提示'
  },
  about: {
    browseArticles: '浏览文章',
    contactMe: '联系我',
    role: '前端开发者 · 技术写作者',
    bio1: '一名热爱技术的前端开发者，专注于 Web 前端工程化与用户体验设计。这个博客是我记录学习笔记、技术思考、软件推荐与项目经验的地方。',
    bio2: '希望把复杂的技术问题讲清楚，把好用的工具分享给大家，让每一次阅读都有所收获。',
    online: '在线创作中',
    focusEyebrow: 'FOCUS',
    focusTitle: '我在做什么',
    focusSub: '用写作沉淀经验，用分享连接更多开发者',
    focusWrite: '技术写作',
    focusWriteDesc: '分享前端开发经验、工程化实践与性能优化思路，把复杂问题讲清楚。',
    focusTools: '工具推荐',
    focusToolsDesc: '精选实用软件与小工具，提升日常开发与学习效率。',
    focusTutorial: '教程实战',
    focusTutorialDesc: '从入门到进阶的项目教程，帮助读者建立完整的知识体系。',
    contentEyebrow: 'CONTENT',
    contentTitle: '博客内容方向',
    contentSub: '四大栏目，覆盖从入门到进阶的学习路径',
    techDesc: '前端开发、性能优化、工程实践',
    softwareDesc: '小工具、办公与开发效率软件',
    tutorialDesc: '入门到进阶的系统化学习',
    resourceDesc: '学习资料、开源项目与书籍',
    statArticles: '文章总数',
    statTech: '技术文章',
    statSoftware: '软件推荐',
    statTutorialResource: '教程 & 资源',
    techGroupFront: '前端框架',
    techGroupLang: '语言与样式',
    techGroupEng: '工程化',
    techGroupOther: '其他'
  },
  sponsor: {
    badge: '赞助会员',
    title: '支持{name}，解锁更多优质内容',
    desc: '您的赞助将帮助站点持续更新教程、软件推荐与技术文章。选择合适方式开通或续费会员。',
    memberUntil: '当前赞助有效期至',
    renewNote: '续费将在到期日基础上延长',
    plansRenew: '续费套餐',
    plansBuy: '会员套餐',
    plansDirectTip: '选择套餐完成赞助，支付成功后自动开通会员',
    plansExternalTip: '选择合适套餐前往发卡平台购买，购买后返回本站兑换 CDK 激活',
    plansIntroTip: '以下为会员套餐介绍，购买后请使用兑换码激活',
    originalPrice: '原价 ¥{price}',
    unitPrice: '折合 {unit}',
    renew: '续费',
    sponsorNow: '立即赞助',
    goBuy: '前往购买',
    onlineBuy: '在线购买会员',
    empty: '会员购买功能暂未开放，请联系管理员',
    faqTitle: '常见问题'
  },
  profile: {
    member: '赞助会员',
    normalUser: '普通用户',
    joinedAt: '加入于 {date}',
    memberUntil: '赞助至 {date}',
    changeAvatar: '更换头像',
    admin: '系统后台',
    renew: '续费赞助',
    openSponsor: '开通赞助',
    history: '浏览记录',
    orders: '订单',
    unlocked: '已解锁',
    sideLabel: '账户中心',
    navAria: '个人中心导航',
    tabInfo: '个人信息',
    tabInfoShort: '资料',
    tabSecurity: '账号安全',
    tabSecurityShort: '安全',
    tabHistory: '浏览历史',
    tabHistoryShort: '历史',
    tabPoints: '我的积分',
    tabPointsShort: '积分',
    tabMember: '赞助会员',
    tabMemberShort: '会员',
    tabOrders: '赞助订单',
    tabOrdersShort: '订单'
  },
  copyright: {
    backHome: '返回首页',
    title: '版权声明',
    desc: '欢迎访问「{name}」网站。请仔细阅读以下条款，使用本站即表示您已阅读并同意本声明的全部内容。',
    updated: '最后更新：2026 年 3 月 10 日',
    effective: '生效日期：2026 年 1 月 1 日',
    toc: '目录',
    contactPrefix: '如您对本声明有任何疑问，请通过邮箱',
    contactSuffix: '与我们联系。我们将在合理期限内予以回复。',
    enNotice: '英文版本仅供参考；如与中文内容不一致，以中文为准。'
  },
  redirect: {
    back: '返回上一页',
    leaving: '即将离开本站',
    invalid: '链接无效',
    leavingDesc: '您即将访问第三方网站，请确认目标地址后再继续。',
    invalidDesc: '无法识别或解析该链接，请检查地址是否正确。',
    targetSite: '目标网站',
    copy: '复制',
    copied: '已复制',
    linkName: '链接名称',
    fromArticle: '来源文章',
    safety: '安全提示',
    tip1: '第三方网站的内容、隐私政策与安全措施由该网站自行负责。',
    tip2: '请勿在未知页面输入账号、密码或支付信息。',
    tip3: '如遇可疑页面，请立即关闭并返回本站。',
    cancel: '取消返回',
    confirm: '确认前往',
    countdown: '点击确认后将在新标签页打开目标链接，本站页面保持不变',
    invalidReason: '可能原因：链接格式错误、协议不受支持，或缺少跳转参数。',
    backHome: '返回首页',
    footerTip: '{name} 对外链访问进行安全提示，保护您的浏览体验'
  },
  common: {
    langSwitched: '已切换语言',
    tip: '提示'
  }
}
